class UpdateCartNotification extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector("#update-cart-wrapper");
    this.acceptBtn = this.querySelector("#agree-to-update-cart");
    this.acceptBtnLoading = this.querySelector("#agree-to-update-cart-loading");
    this.shouldRefresh = true;
    this.sessionKey = "UPDATED_CART";
  }

  connectedCallback() {
    const sessionCart = localStorage.getItem(this.sessionKey) === "t";
    if (this.shouldRefresh && !sessionCart) {
      this.openUpdateModal();
    }

    this.fetchCurrentCart();
  }

  /**
   * Fetches the current user cart.
   * - If the shouldRefresh is set to true, it attaches the event listener to the button.
   * - Else, it does nothing and keeps the modal empty.
   */
  async fetchCurrentCart() {
    const cart = fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    cart.then((v) => {
      if (v?.items?.length == 0) {
        return;
      }

      if (!this.shouldRefresh) {
        return;
      }

      this.setAcceptButtonListener();
    });
  }

  /**
   * Updates the current cart with a new _trigger property.
   * This does not change any item, but retriggers the cart transform function.
   */
  updateCart = async () => {
    const a = fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          _trigger: Date.now().toString(), // dummy attribute
        },
      }),
    })?.then((v) => {
      return v?.json();
    });

    a.then((v) => {
      console.log("Cart updated!");
      this.closeUpdateModal();
      sessionStorage.setItem(this.sessionKey, "t");

      return v;
    })?.catch((e) => {
      console.error(e);
      this.setButtonTo("REGULAR");
    });
  };

  /**
   * Sets the button to loading state and performs the update cart method.
   */
  async updateCartAction() {
    this.setButtonTo("LOADING");
    this.updateCart();
  }

  /**
   * Click Event Listener for the accept button.
   */
  async setAcceptButtonListener() {
    this.acceptBtn.addEventListener("click", () => {
      this.updateCartAction();
    });
  }

  /**
   * Changes the state of the modal button.
   * Takes the data-modal-item-show attribute to show/hide the modal.
   * @param {ModalButtonState} state The wanted button state.
   */
  setButtonTo(state) {
    switch (state) {
      case "LOADING": {
        this.acceptBtn.setAttribute("data-modal-item-show", "false");
        this.acceptBtnLoading.setAttribute("data-modal-item-show", "true");
        break;
      }
      case "REGULAR": {
        this.acceptBtn.setAttribute("data-modal-item-show", "true");
        this.acceptBtnLoading.setAttribute("data-modal-item-show", "false");
        break;
      }
      default:
        throw Error("State not allowed.");
    }
  }

  /**
   * Opens the modal.
   */
  openUpdateModal() {
    this.wrapper.style.display = "block";
    document.body.classList.add("drawer-container");
  }

  /**
   * Closes the modal.
   */
  closeUpdateModal() {
    this.wrapper.style.display = "none";
    document.body.classList.remove("drawer-container");
  }
}

customElements.define("update-cart-notification", UpdateCartNotification);
